export const MerchantDefaultRoutes = {
  ONBOARDING_ROUTE: 'onboarding',
  DASHBOARD_ROUTE: 'dashboard',
};

export default MerchantDefaultRoutes;
